import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import find from 'lodash/find';
import { NavDropdown, Dropdown, MenuItem } from 'react-bootstrap';
import { SharedMessages as sharedMessages } from 'ecs-react-components/dist/index.es';
import {
  languageChange,
  putPreferredLanguageByPatient,
  putPreferredLanguage,
} from '../../redux/modules/language/language-middleware';
import { loadSupportedLanguages } from '../../redux/modules/capability/capability-middleware';

class LanguageSelectionDropdown extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(loadSupportedLanguages());
  }

  handleLanguageSelect = (lang) => () => {
    const {
      dispatch,
      patientId,
      userId,
      isAuthRep,
    } = this.props;

    if (isAuthRep) {
      dispatch(putPreferredLanguage(userId, lang));
    } else if (patientId) {
      dispatch(putPreferredLanguageByPatient(patientId, lang));
    } else {
      dispatch(languageChange(lang));
    }
  }

  languageText(lang) {
    return <FormattedMessage {...lang} />;
  }

  render() {
    const {
      intl: {
        formatMessage,
      },
      supportedLanguages,
      language: {
        languageCode,
      },
      selectId,
      inMenu,
      visibilityClass,
    } = this.props;

    if (!supportedLanguages || !supportedLanguages.length) {
      return null;
    }

    const currentLanguage = find(supportedLanguages, { languageCode }) || supportedLanguages[0];

    const ariaLabel = formatMessage(sharedMessages.dropdown.languageSelected) + ' ' +
      currentLanguage.displayName;
    const currentLanguageDisplay = currentLanguage.displayName || '';
    const dropDownId = selectId || 'languageDropdown';
    return (
      inMenu ?
        <NavDropdown id={dropDownId} className={visibilityClass}
          title={ <span className="fa fa-globe" aria-hidden="true" /> }
          aria-label={ariaLabel}
        >
          {
            supportedLanguages.map((lang) =>
              (
                <MenuItem
                  key={lang.languageCode}
                  onClick={this.handleLanguageSelect(lang.languageCode)}
                >
                  {lang.displayName}
                </MenuItem>
              ))
          }
        </NavDropdown> :
        <Dropdown id={dropDownId} className="top-right-utility-buttons themed pull-right">
          <Dropdown.Toggle className="btn-primary">
            <span className="fa fa-globe language-dropdown-icon" aria-hidden="true" >&nbsp;</span>
            {currentLanguageDisplay}
          </Dropdown.Toggle>
          <Dropdown.Menu aria-label={ariaLabel}>
            {
              supportedLanguages.map((lang) =>
                (
                  <MenuItem key={lang.languageCode} onClick={this.handleLanguageSelect(lang.languageCode)}>
                    {lang.displayName}
                  </MenuItem>
                )
              )
            }
          </Dropdown.Menu>
        </Dropdown>
    );
  }
}

LanguageSelectionDropdown.propTypes = {
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  supportedLanguages: PropTypes.array.isRequired,
  userId: PropTypes.number,
  selectId: PropTypes.string,
  intl: PropTypes.object,
  inMenu: PropTypes.bool,
  visibilityClass: PropTypes.string,
  patientId: PropTypes.number,
  isAuthRep: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  language: state.language,
  supportedLanguages: state.capability.languages,
  userId: state.profile.user.userId,
  patientId: state.profile.patient.patientId,
  isAuthRep: state.profile.user.isAuthorizedRepresentative,
});

export default connect(mapStateToProps)(injectIntl(LanguageSelectionDropdown));